export const NEW_COMMERCIAL_CONTACT = 'newCommercialContact';
export const DELETE_COMMERCIAL_CONTACT = 'delete-commercial-contact';
export const NEW_COMMERCIAL_FACILITY = 'newCommercialFacility';
export const DELETE_COMMERCIAL_FACILITY = 'delete-commercial-facility';
